import React from "react"
import CarouselAutoScroll from "@components/nonDLSComponents/AutoScrollCarousel/AutoScrollCarousel.js"
import { getAssetPath } from "@commonUtils"
import css from "../Auth.scss"
const Slider = () => {
    return (
        <div className={`${css.leftContainer}`}>
            <CarouselAutoScroll
                infoArray={[
                    {
                        image: {
                            src: getAssetPath("login-signup/Health-Related-Queries.png"),
                        },
                        title: "Make Healthcare Simpler",
                        description:
                            "Get medicine information, order medicines, book lab tests and consult doctors online from the comfort of your home.",
                    },
                    {
                        image: {
                            src: getAssetPath("login-signup/Know-Your-Medicines.png"),
                        },
                        title: "Know Your Medicines",
                        description:
                            "View medicine information like usage, side effects and cheaper substitutes before you take them.",
                    },
                    {
                        image: {
                            src: getAssetPath("login-signup/Home-Delivery-of-Medicines.png"),
                        },
                        title: "Medicines, Home Delivered",
                        description:
                            "Order any medicine or health product and we’ll deliver it for free. Enjoy discounts on everything.",
                    },
                    {
                        image: {
                            src: getAssetPath("login-signup/Lab-Tests-at-Home.png"),
                        },
                        title: "Lab Tests at Home",
                        description:
                            "Book any test from any lab. We'll collect the sample and send the reports. Save up to 80% every time.",
                    },
                    {
                        image: {
                            src: getAssetPath("login-signup/Your-Go-To-Health-App.png"),
                        },
                        title: "Health Related Queries?",
                        description:
                            "Consult our certified doctors from anywhere, anytime, and for free. We guarantee your privacy.",
                    },
                ]}
                width="130px"
                height="130px"
            />
        </div>
    )
}

export default Slider
